// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { connect, useDispatch, useStore, useSelector } from '/app/node_modules/@umijs/plugins/libs/dva.tsx';
export { getDvaApp } from './dva';
